export const defaultHotKeys = {
  Administration: {
    a: { label: 'Go to Administration', path: '/app/administration' },
    s: { label: 'Go to Settings', path: '/app/administration/settings' },
    t: { label: 'Go to Teams', path: '/app/administration/teams' },
    T: {
      label: 'Add New Team',
      path: '/app/administration/teams?open_modal=create_team',
    },
    r: {
      label: 'Register Administrator',
      path: '/app/administration?open_modal=register_admin',
    },
    p: {
      label: 'Go to Roles and Permissions',
      path: '/app/administration/roles-permissions',
    },
    P: {
      label: 'Add New Role',
      path: '/app/administration/roles-permissions?open_modal=create_role',
    },
    g: {
      label: 'Manage Global Permissions',
      path: '/app/administration/global-permissions',
    },
    A: {
      label: 'Search for Administrator',
      path: '/app/administration?focus=search_admin',
    },
  },
  Finance: {
    f: { label: 'Go to Finance', path: '/app/finance' },
    c: {
      label: 'Setup New Country',
      path: '/app/finance/countries?open_modal=setup_country',
    },
    R: {
      label: 'Reset System Currency',
      path: '/app/finance?reset_currency=true',
    },
  },
  Users: {
    u: { label: 'Go to Users', path: '/app/users' },
  },
  Transactions: {
    x: { label: 'Go to Transactions', path: '/app/transactions' },
  },
  KYC: {
    k: { label: 'Go to KYC', path: '/app/kyc' },
    K: { label: 'Go to SumSub', path: '/app/kyc/sumsub' },
  },
  Messaging: {
    m: { label: 'Go to Conversations', path: '/app/conversations' },
    C: { label: 'Go to Contacts', path: '/app/conversations/contacts' },
  },
  Notifications: {
    n: { label: 'Go to Notifications', path: '/app/notifications' },
  },
  Account: {
    A: { label: 'Go to Account Settings', path: '/app/account/settings' },
    L: { label: 'Logout of Account', path: '/logout' },
    l: { label: 'Lock Account (Displays Lockscreen)', path: '/lock' },
  },
  System: {
    d: { label: 'Go to Documentation', path: '/documentation' },
    U: { label: 'Go to System Updates', path: '/app/system-updates' },
    T: { label: 'Terms of Service Update', path: '/app/legal/terms' },
    V: { label: 'Privacy Policy Update', path: '/app/legal/privacy' },
    E: { label: 'Customer Acceptance Update', path: '/app/legal/acceptance' },
    b: { label: 'Report a Bug', path: '/support/bug-report' },
    D: { label: 'Enter Debugging Mode', path: '/debug' },
    o: { label: 'Open Console', path: '/dev/console' },
    M: { label: 'Go to Mobile App Changes', path: '/app/mobile-changelog' },
    z: { label: 'Toggle Dark Mode', path: '/toggle-dark' },
    y: { label: 'Go to Activity Logs', path: '/app/logs' },
    i: { label: 'Go to Integrations', path: '/app/integrations' },
    F: { label: 'Toggle Full Screen Mode', path: '/toggle-fullscreen' },
    Z: { label: 'Remove Full Screen Mode', path: '/exit-fullscreen' },
  },
};
